import React from 'react';
import CTProduct from './CTProduct';
import CTSection from './CTSection';
import { NeuroMessage, ProductGroup } from '../../components';
import useNeuroState from '../../state';
import { ConversationTestModulePropTypes } from '../../utils';

const CTProductsAll = ({ isFullHeight, width, ...rest }) => {
  const { testPageData = {} } = useNeuroState();
  const { productGroups } = testPageData;

  const renderProductGroup = (productGroup, subGroups, products) => {
    const cssBEM = 'product-group';

    return (
      <div className={cssBEM} key={productGroup.name}>
        <div className={`${cssBEM}__header count-${products.length || 0}`}>
          <h1>
            <NeuroMessage id={`productGroup.${productGroup.name}`} tagName="span"/>
          </h1>
        </div>
        {subGroups || null}
        {products || null}
      </div>
    );
  };

  return (
    <CTSection
      isFullHeight={isFullHeight}
      className="all-products"
      width={width}
      title="All Products"
    >
      {(productGroups[0].groups || []).map((g) => (
        <ProductGroup
          group={g}
          renderGroupFn={renderProductGroup}
          renderProductFn={(product) => (
            <CTProduct product={product} {...rest} />
          )}
          key={g.name}
        />
      ))}
    </CTSection>
  );
};

CTProductsAll.propTypes = {
  ...ConversationTestModulePropTypes,
};

export default CTProductsAll;
